module.exports = __webpack_public_path__ + "img/photo_2023-08-31_17-32-55.4b4e8799.png";